import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
import DropdownInput from './DropdownInput';
import DropdownInput_dropdown_updates from './DropdownInput.dropdown_updates';
export default withFeatureBranch({
    dropdown_updates: DropdownInput_dropdown_updates,
})(DropdownInput);
//# sourceMappingURL=index.js.map